export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/ms.lyaml"));
at({ "ms": { "public": { "sampleString": "Rentetan sampel" } } });
};